import React from 'react'
import { Button, Modal } from 'react-bootstrap'

export const ErrorModal = ({modalProps,handleClose}) => {
  return (
    <Modal centered show={modalProps.show} handleClose={handleClose}>
    <Modal.Header>
      <Modal.Title>Error</Modal.Title>
    </Modal.Header>
    <Modal.Body>{modalProps.message}</Modal.Body>
    <Modal.Footer>
      <Button variant="primary" onClick={handleClose}>
        Close
      </Button>
    </Modal.Footer>
  </Modal>
  )
}
